module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid2.ed414e36.png";